module.exports = {"body":"<div class=\"notfound-404\">\n<h1>404</h1>\n<p>Page not found.</p>\n<img src=\"/images/404.png\" />\n<p>Someone might have broken the space-time continuum...<p>\n</div>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./404.html
 ** module id = 1245
 ** module chunks = 0
 **/